import React, { useState } from 'react';
import { Play } from 'lucide-react';

/**
 * YouTube の埋め込み。最初はサムネイルと再生ボタンだけを出し、押したらその場でプレーヤーを読み込んで再生する
 * （何本も並べても重くならないように）。プレーヤーは youtube-nocookie.com を使う。
 */
export default function YouTubeEmbed({ episode, big = false }) {
  const [playing, setPlaying] = useState(false);
  return (
    <div className="relative aspect-video w-full overflow-hidden border border-line bg-gray-950">
      {playing ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${episode.id}?autoplay=1&rel=0`}
          title={`SALT2 Podcast ${episode.no} ${episode.title}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 h-full w-full"
        />
      ) : (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          data-cursor="PLAY"
          aria-label={`${episode.no} ${episode.title} を再生する`}
          className="group absolute inset-0 block h-full w-full"
        >
          <img
            src={`https://i.ytimg.com/vi/${episode.id}/${big ? 'maxresdefault' : 'hqdefault'}.jpg`}
            onError={(e) => {
              // 高画質のサムネイルが無い回は、標準のものに替える
              if (!e.currentTarget.src.includes('hqdefault')) e.currentTarget.src = `https://i.ytimg.com/vi/${episode.id}/hqdefault.jpg`;
            }}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-quart group-hover:scale-[1.03]"
          />
          <span className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" aria-hidden="true" />
          <span
            className={`absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-live text-[#F6F4EF] transition-transform duration-300 group-hover:scale-110 ${
              big ? 'h-20 w-20' : 'h-12 w-12'
            }`}
            aria-hidden="true"
          >
            <Play size={big ? 30 : 20} fill="currentColor" className="ml-1" />
          </span>
          {/* 長さは自動の取り込みで取れないことがある（そのときは出さない） */}
          {episode.duration && (
            <span className="absolute bottom-3 right-3 bg-black/75 px-2 py-0.5 text-[11px] font-semibold text-white tnum">
              {episode.duration}
            </span>
          )}
        </button>
      )}
    </div>
  );
}
